import GModal from "components/ui/modal/Modal";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Box, Flex, Stack, useToast } from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import GButton from "components/ui/button/Button";
import Input from "components/form/Input";
import MultiSelect from "components/ui/multiSelect/MultiSelect";
import { useDispatch, useSelector } from "react-redux";
import {
  getBranchesDropDown,
  getTransfersList,
  updateTransfers,
} from "../services/transfersServices";

const EditTransfers = ({ onClose, id }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const toast = useToast({
    position: "top",
    duration: 3000,
    status: "success",
  });
  const toast2 = useToast({ position: "top", duration: 3000, status: "error" });
  const { handleSubmit, setValue, control } = useForm();

  const transfersData = useSelector((state) => state.inventoryTransfers);
  console.log("transfersData" ,transfersData);

  useEffect(() => {
    dispatch(getBranchesDropDown());
  }, [dispatch]);

  return (
    <GModal
      onClose={onClose}
      modalHeader={t("pages.transfers.edit_transfers")}
      modalContent={
        <Box p={4}>
          <form
            onSubmit={handleSubmit((values) => {
              values.SourceId = values.SourceId?.BranchId;
              values.DestinationId = values.DestinationId?.BranchId;
              values.TransfersId = id;
              values.UserId = localStorage.getItem("userId");
              if (
                values.SourceId === undefined ||
                values.DestinationId === undefined
              ) {
                toast2({ description: t("validation.choose_first") });
              } else {
                dispatch(updateTransfers(values))
                  .unwrap()
                  .then((_) => {
                    toast({
                      description: t("pages.transfers.updated_successfuly"),
                    });
                    dispatch(getTransfersList());
                    onClose();
                  });
              }
            })}
          >
            <Stack spacing={6}>
              <MultiSelect
                title={t("pages.transfers.source")}
                data={transfersData.BranchesDropDown.map((el) => ({
                  ...el,
                  label: el.BranchName,
                  value: el.BranchId,
                }))}
                isMulti={false}
                isRequired={true}
                onChange={(e) => setValue("SourceId", e)}
              />

              <MultiSelect
                title={t("pages.transfers.destination")}
                data={transfersData.BranchesDropDown.map((el) => ({
                  ...el,
                  label: el.BranchName,
                  value: el.BranchId,
                }))}
                isMulti={false}
                isRequired={true}
                onChange={(e) => setValue("DestinationId", e)}
              />

              <Input
                label={t("pages.transfers.receving_date")}
                name="ReceivingDueDate"
                control={control}
                type="date"
                labelStyle={{ textTransform: "capitalize" }}
                isFormController
                onChange={(e) => setValue("ReceivingDueDate", e.target.value)}
              />

              <Input
                label={t("pages.transfers.notes")}
                labelStyle={{ textTransform: "capitalize" }}
                placeholder={t("pages.transfers.notes")}
                name="Notes"
                isFormController
                control={control}
              />

              <Flex gap={4}>
                <GButton
                  type="submit"
                  title={t("general.save")}
                  bg="primary"
                  color="light"
                  border="1px solid transparent"
                  hover={{
                    color: "primary",
                    borderColor: "primary",
                    bg: "none",
                  }}
                />
                <GButton
                  title={t("general.close")}
                  onClick={onClose}
                  bg="red.600"
                  border="1px solid transparent"
                  color="light"
                  hover={{
                    color: "red.600",
                    borderColor: "red.600",
                    bg: "none",
                  }}
                />
              </Flex>
            </Stack>
          </form>
        </Box>
      }
    />
  );
};

export default EditTransfers;
